import { render } from "./sidebar.vue?vue&type=template&id=76a1f86b&scoped=true&lang=pug"
import script from "./sidebar.vue?vue&type=script&lang=js"
export * from "./sidebar.vue?vue&type=script&lang=js"

import "./sidebar.vue?vue&type=style&index=0&id=76a1f86b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76a1f86b"]])

export default __exports__